import React from "react"
import SelectDropdown from "../SelectDropdown"
import FormSection from "../FormSection"
import TextAreaInput from "../TextAreaInput"

export default function Builder() {
  const yesNo = [
    { value: "", label: "Please Select" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ]

  return (
    <FormSection title="Your Builder" className="bg-gray-100">
      <div className="grid grid-cols-2 gap-y-6">
        <SelectDropdown
          label="Have you considered your builder?"
          name="builder_considered"
          as="select"
          options={yesNo}
          className="flex flex-col mr-32"
        />
        <div />
        <div className="flex flex-col space-y-4 mr-32">
          <div className="subtitle">
            <p>
              If <span className="text-tertiary">yes</span>
            </p>
            <p>
              Please list below the builders you have been contemplating
              engaging to carry out your build.
            </p>
          </div>
          <TextAreaInput
            label=""
            name="list_of_builders_considered"
            className="flex flex-col col-span-2"
          />
        </div>
        <div className="flex flex-col mr-32">
          <div className="subtitle mb-4">
            <p>
              If <span className="text-tertiary">no</span>
            </p>
            <p>
              Please list below what attributes you would like from a builder.
            </p>
          </div>
          <TextAreaInput
            label=""
            name="builder_attributes_desired"
            className="flex flex-col col-span-2 mt-auto"
          />
        </div>
      </div>
    </FormSection>
  )
}
